<template>
  <v-container class="account">
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="8"
        xl="6"
        offset-lg="2"
        offset-xl="3"
        pt="0"
      >
        <h1>
          {{ $t('payment_method.txt.my_account_details') }}
        </h1>
        <div class="description">
          <div>
            {{ $t('payment_method.txt.description') }}
          </div>
        </div>
        <div
          v-if="loading"
          class="loader"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="8"
        xl="6"
        offset-lg="2"
        offset-xl="3"
      >
        <v-card>
          <v-form
            v-if="showForm"
            ref="form"
            v-model="valid"
            lazy-validation
            class="form pa-8"
          >
            <img
              :src="$t('payment_method.img.truck.img')"
              :alt="$t('payment_method.img.truck.alt')"
              class="truck d-none d-sm-block"
            >
            <v-row>
              <v-col
                cols="12"
                sm="9"
              >
                <v-row>
                  <v-col
                    cols="12"
                    class="section-title mt-8"
                  >
                    <div class="horizontal-spacer" />
                    <h2>{{ $t('payment_method.txt.payment') }}</h2>
                    <div class="horizontal-spacer" />
                  </v-col>
                  <v-col cols="12">
                    <span class="caption">{{ $t('payment_method.txt.choose_payment_method') }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="payment-buttons py-1"
                  >
                    <v-dialog
                      v-model="dialogCCard"
                      max-width="600px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          class="elevation-0"
                          :class="{active : activePaymentMethod == 'CreditCard' }"
                          outlined
                          height="48"
                          color="mid"
                          v-on="on"
                          @click="handleClick('creditCard')"
                        >
                          <span
                            class="payment-choosen"
                          >{{ $t('payment_method.txt.credit_card') }}</span>
                        </v-btn>
                      </template>
                      <v-card>
                        <div
                          v-if="loadingCCard"
                          class="loader-dialog"
                        >
                          <v-progress-circular
                            indeterminate
                            color="primary"
                          />
                        </div>
                        <div id="zuora_payment" />
                        <!-- <iframe
                          id="paymentiframeccard"
                          name="paymentiframeccard"
                          class="payment-iframe"
                          :src="cCardPaymentURL"
                        /> -->
                      </v-card>
                    </v-dialog>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="payment-buttons py-1"
                  >
                    <v-btn
                      class="elevation-0"
                      :class="{active : activePaymentMethod == 'BankTransfer' }"
                      outlined
                      height="48"
                      min-width="140"
                      color="mid"
                      @click="handleClick('directDebit')"
                    >
                      <span class="payment-choosen">{{ $t('payment_method.txt.direct_debit') }}</span>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="proceed"
                  >
                    <v-btn
                      class="mt-6"
                      :disabled="isDisabled"
                      @click="handleSubmit"
                    >
                      {{ $t('payment_method.txt.proceed') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="notification"
      top
      :color="notificationType"
    >
      {{ notificationText }}
      <v-btn
        color="white"
        text
        @click="notification = false"
      >
        {{ $t('payment_method.txt.close') }}
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import apiCalls from '@/helpers/apiCall'
import api from '@/helpers/api'
import { mapActions } from 'vuex'

export default {
  name: 'PaymentInformation',
  data() {
    return {
      cCardPaymentURL: '',
      dialogCCard: false,
      dialogDDebit: false,
      valid: true,
      submitted: false,
      isReadonly: false,
      notification: false,
      notificationText: '',
      notificationType: 'success',
      loading: false,
      loadingCCard: false,
      showForm: false,
      activePaymentMethod: ''
    }
  },
  computed: {
    isDisabled: function() {
      // TODO: Adjust the disable button rules
      return false
    }
  },
  // * Adds the zuora js file to the header, for rendering and callback handling
  mounted() {
    const zuora = document.createElement('script')
    zuora.setAttribute(
      'src',
      'https://static.zuora.com/Resources/libs/hosted/1.3.1/zuora-min.js'
    )
    zuora.async = true
    document.head.appendChild(zuora)
  },
  async created() {
    await this.getAccountInformation()
  },
  methods: {
    ...mapActions('notification', ['setSnackbar']),
    async handleClick(e) {
      if (e == 'directDebit') {
        // * When the button is clicked makes the request to get the info from the backend
        const dDebitPaymentURL = await this.getPaymentURl(
          api.PaymentGetDDebitHPP
        )
        // * If the request returns a String, then it's the url.
        if (typeof dDebitPaymentURL === 'string') {
          window.open(dDebitPaymentURL, '_self')
        } else {
          // * If it's an error, checks if it has an extra to complement the message, then build the error message to show to the user.
          const errorMessage = dDebitPaymentURL.extra
            ? `${dDebitPaymentURL.message} - ${dDebitPaymentURL.extra}`
            : dDebitPaymentURL.message
          this.setSnackbar({
            showing: true,
            type: 'error',
            text: errorMessage
          })
        }
      } else if (e == 'creditCard') {
        Z.setEventHandler('onloadCallback', () => {
          // * Turns off the loading when the rendering is done.
          this.loadingCCard = false
        })
        this.loadingCCard = true
        // * Gets the params for the zuora rendering function
        const cCardPaymentURL = await this.getPaymentURl(api.PaymentGetCCardHPP)
        // * Build the params for the Z.render function
        const params = {
          tenantId: cCardPaymentURL.tenantId,
          id: cCardPaymentURL.id,
          token: cCardPaymentURL.token,
          signature: cCardPaymentURL.signature,
          key: cCardPaymentURL.key,
          url: cCardPaymentURL.pageUrl,
          style: 'inline',
          submitEnabled: true,
          locale: localStorage.getItem('language'),
          // eslint-disable-next-line @typescript-eslint/camelcase
          param_gwOptions_shopperInteraction: 'Ecommerce'
        }
        const prepopulateFields = {}
        // * Renders the credit card form in the specified element with id="zuora_payment"
        Z.render(params, prepopulateFields, this.handleCallback)
      }
    },
    getAccountInformation() {
      this.loading = true
      return apiCalls
        .get(api.AccountDetails, '', '')
        .then(res => {
          this.activePaymentMethod =
            res.data.paymentMethodInfo.paymentMethodType
          this.loading = false
          this.showForm = true
        })
        .finally(() => {
          this.loading = false
          this.showForm = true
        })
    },
    getPaymentURl(apiEndpoint) {
      return apiCalls.get(apiEndpoint, '', '').then(res => {
        return res.data
      })
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    resetForm() {
      this.$refs.form.reset()
    },
    handleSubmit() {
      this.$router.push({
        name: 'home'
      })
    },
    // * Handles the callback for the credit card form submit

    handleCallback(response) {
      this.dialogCCard = false
      if (response.success) {
        // Handle the response after the Payment Page is
        // successfully submitted.
        this.setSnackbar({
          showing: true,
          type: 'success',
          text: this.$t('payment_method.txt.notification_success')
        })
        const payload = {
          referenceID: response.refId,
          autoPay: true
        }
        apiCalls.post(api.PaymentSetMethod, '', '', payload).then(res => {
          if (res.status == 200) {
            this.$router.push({
              name: 'payment_confirmation'
            })
          } else {
            this.setSnackbar({
              showing: true,
              type: 'error',
              text: res.data.message
            })
          }
        })
      } else {
        if (response.responseFrom == 'Response_From_Submit_Page') {
          this.setSnackbar({
            showing: true,
            type: 'error',
            text: response.errorMessage
          })
        } else {
          // Handle the error response when the Payment Page
          // request failed.
          this.setSnackbar({
            showing: true,
            type: 'error',
            text: response.errorMessage
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.account {
  .loader {
    text-align: center;
    padding-top: 48px;
  }
  h1 {
    margin-bottom: 22px;
    font-size: 3rem;
    font-weight: 300;
    line-height: normal;
    color: var(--v-dark-base);
    text-align: left;
  }
  .description {
    font-size: 0.875rem;
    color: var(--v-slate-base);
  }
  .form {
    font-size: 0.875rem;
    position: relative;
    overflow: initial;
    @media screen and (max-width: 960px) {
      overflow: hidden;
      border-radius: 10px 10px 0 0;
    }
    .truck {
      top: 32px;
      right: -116px;
      display: flex;
      width: 232px;
      position: absolute;
      z-index: 2;
    }
    .section-title {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      padding: 0 16px 30px;
      h2 {
        margin: 0 10px;
        color: var(--v-bluegrey-base) !important;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: normal;
      }
      .horizontal-spacer {
        border-top: 1px solid var(--v-pale-three-base);
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
      }
    }
    .payment-buttons {
      .v-btn {
        font-size: 0.875rem;
        font-weight: bold;
        text-align: center;
        border: solid 1px var(--v-cloudy-base) !important;
        border-radius: 4px !important;
        width: 100%;
      }
      .active {
        background-color: var(--v-cloudy-base) !important;
      }
    }
    .proceed {
      .v-btn {
        height: 48px !important;
        border-radius: 5px;
        background-image: linear-gradient(
          to bottom,
          #266cab 0%,
          #01529c
        ) !important;
        font-size: 0.875rem;
        font-weight: bold;
        text-align: center;
        color: white !important;
        width: 100%;
        &--disabled {
          background-image: none !important;
        }
      }
    }
  }
  .vat-checked {
    margin-top: -25px;
    padding: 0 24px;
    font-size: 0.75rem;
    font-weight: bold;
    color: var(--v-success-darken1);
  }
}
.loader-dialog {
  text-align: center;
  padding: 8px;
}
.dialog-changes-label {
  font-size: 0.75rem;
  font-weight: bold;
  color: var(--v-mid-base) !important;
  text-transform: uppercase;
}
.dialog-changes-value {
  font-size: 0.75rem;
}
.payment-iframe {
  width: 100%;
  height: 440px;
}
</style>